module.exports = __webpack_public_path__ + "3d7fa0a1e4d6abdd113e8ea7f7f2f4ad.gif";